export const CHANGE_TITLE = 'CHANGE_TITLE'
export const POPULATE_SHOPPING_LISTS = 'POPULATE_SHOPPING_LISTS'
export const ADD_SHOPPING_LIST = 'ADD_SHOPPING_LIST'
export const DELETE_SHOPPING_LIST = 'DELETE_SHOPPING_LIST'



// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js